import Vue from "vue";
import Vuex from "vuex";
import Service from "../services/search";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    schools: [],
    suburbs: [],
    trips: [],
    show_results: false,
  },
  mutations: {
    SET_SCHOOLS(state, schools) {
      state.schools = schools;
    },
    SET_SUBURBS(state, suburbs) {
      state.suburbs = suburbs;
    },
    SET_RESULTS(state, trips) {
      state.trips = trips;
    },
    RESET_SEARCH(state) {
      state.trips = [];
    },
    SHOW_RESULTS(state) {
      state.show_results = true;
    },
    HIDE_RESULTS(state) {
      state.show_results = false;
    },
  },
  actions: {
    fetchSchools({ commit }) {
      return Service.getSchoolList()
        .then((res) => {
          commit("SET_SCHOOLS", res);
        })
        .catch((err) => {
          throw err;
        });
    },
    fetchSuburbs({ commit }) {
      return Service.getSuburbList()
        .then((res) => {
          commit("SET_SUBURBS", res);
        })
        .catch((err) => {
          throw err;
        });
    },
    fetchResultsByDestination({ commit }, destination) {
      return Service.getResultsByDestination(destination)
        .then((res) => {
          commit("SET_RESULTS", res);
          commit("SHOW_RESULTS");
        })
        .catch((err) => {
          throw err;
        });
    },
    fetchResultsBySchoolSuburb({ commit }, { school, suburb }) {
      return Service.getResultsBySchoolSuburb(school, suburb)
        .then((res) => {
          commit("SET_RESULTS", res);
          commit("SHOW_RESULTS");
        })
        .catch((err) => {
          throw err;
        });
    },
    resetSearch({ commit }) {
      commit("RESET_SEARCH");
      commit("HIDE_RESULTS");
    },
  },
});
